/**
 * Inicialización de la clase AppInfoModel, modelo para la configuración de la aplicación
 *
 * *Set AppInfoModel class, app config model*
 *
 * @access public
 * @type {class}
 */
export class AppInfoModel {

  /**
   * Canal de comunicación de la aplicación (portalpn)
   *
   * *App's channel communication (portalpn)*
   *
   * @type {string} channelId
   */
  channelId: string;

  /**
   *  Plataforma de la aplicación (portalpn)
   *
   * *App's platform (portalpn)*
   *
   * @type {string} platform
   */
  platform: string;

  /**
   *  Versión de la aplicación
   *
   * *App's version*
   *
   * @type {string} appVersion
   */
  appVersion: string;

  /**
   *  Validación de la información no disponible de la aplicación
   *
   * *App's unavailable information validation*
   *
   * @type {boolean} frontDocumentScan
   */
  infoUnavailable: boolean;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * @type {string}   channelId       Sets variable as empty
   * @type {string}   platform        Sets variable as empty
   * @type {string}   appVersion      Sets variable as empty
   * @type {boolean}  infoUnavailable Sets variable as true
   *
   */
  constructor() {
    this.channelId = '';
    this.platform = '';
    this.appVersion = '';
    this.infoUnavailable = true;
  }

}
